import _get from 'lodash/get';

import { findAllValues } from 'utils/DICTIONARY';

export default function formatFulfilmentStatus(method) {
  const methodsMap = findAllValues('fulfillmentStatusChoices') || {};
  return _get(methodsMap, method, '');
}
